<template>
    <div class="dml-header-search" data-t="5.20">
        <dm-search-form namespace="dml-header-search"
                        v-on:close="$emit('close')">
            <template slot="submit">
                <dm-icon name="search" :width="24" :height="24" />
            </template>
            <template slot="close">
                <dm-icon name="close" :width="24" :height="24" />
            </template>
        </dm-search-form>
    </div>
</template>
<script>
    import IconComponent from '../shared/icon-component.vue';
    import SearchFormComponent from '../shared/search-form-component.vue';

    export default {
        name: 'dm-search-header',
        components: {
            'dm-search-form': SearchFormComponent,
            'dm-icon': IconComponent,
        },
    };
</script>
